var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhyUsIcon4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.9 25H28.3333C27.4493 25 26.6014 25.3512 25.9763 25.9763C25.3512 26.6014 25 27.4493 25 28.3333V35.9",
    stroke: "#8B5CF6",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.668 5.56641V8.33307C11.668 9.65916 12.1948 10.9309 13.1324 11.8686C14.0701 12.8063 15.3419 13.3331 16.668 13.3331C17.552 13.3331 18.3999 13.6843 19.025 14.3094C19.6501 14.9345 20.0013 15.7824 20.0013 16.6664C20.0013 18.4997 21.5013 19.9997 23.3346 19.9997C24.2187 19.9997 25.0665 19.6485 25.6917 19.0234C26.3168 18.3983 26.668 17.5505 26.668 16.6664C26.668 14.8331 28.168 13.3331 30.0013 13.3331H35.2846",
    stroke: "#8B5CF6",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3346 36.5835V30.0002C18.3346 29.1161 17.9834 28.2683 17.3583 27.6431C16.7332 27.018 15.8854 26.6668 15.0013 26.6668C14.1172 26.6668 13.2694 26.3156 12.6443 25.6905C12.0192 25.0654 11.668 24.2176 11.668 23.3335V21.6668C11.668 20.7828 11.3168 19.9349 10.6917 19.3098C10.0665 18.6847 9.21869 18.3335 8.33464 18.3335H3.41797",
    stroke: "#8B5CF6",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9987 36.6668C29.2034 36.6668 36.6654 29.2049 36.6654 20.0002C36.6654 10.7954 29.2034 3.3335 19.9987 3.3335C10.794 3.3335 3.33203 10.7954 3.33203 20.0002C3.33203 29.2049 10.794 36.6668 19.9987 36.6668Z",
    stroke: "#8B5CF6",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyUsIcon4);
export default __webpack_public_path__ + "static/media/WhyUs-icon-4.18c5e61ccd7e27b621f4a5e7f5b77c90.svg";
export { ForwardRef as ReactComponent };